import { render } from "./order-comment-dialog.vue?vue&type=template&id=705a1560&scoped=true"
import script from "./order-comment-dialog.vue?vue&type=script&lang=js"
export * from "./order-comment-dialog.vue?vue&type=script&lang=js"

import "./order-comment-dialog.vue?vue&type=style&index=0&id=705a1560&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705a1560"]])

export default __exports__